<div class="data-tracking-container" *ngIf="diagnosticReportWorksheetModels?.length > 0">

  <div class="headers" *ngIf="diagnosticReport && !(hideDiagnosticReportDescription$ | async)">
    <p>
      The report below compares destination QNRs along with the OECD and <a class="link pointer" (click)="onShowCountryList($event)">{{diagnosticReport.countryCodes.length}} country calculators</a> and displays any mismatches between the input fields.
    </p>
    <button mat-icon-button (click)="onCloseHeader()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <mat-accordion class="data-tracking-mat-accordion" multi="true">
    <mat-expansion-panel  class="diagnostic-report-mat-expansion-panel"
                          (opened)="onWorksheetOpen(diagnosticReportWorksheet.worksheetName)"
                          (closed) = "onWorksheetClose(diagnosticReportWorksheet.worksheetName)"
                          [expanded] = "diagnosticReportSelectedRecordInfo.worksheetName === diagnosticReportWorksheet.worksheetName"

                          *ngFor="let diagnosticReportWorksheet of diagnosticReportWorksheetModels">
      <mat-expansion-panel-header [collapsedHeight]="'50'" [expandedHeight]="'50'">
        <mat-panel-title>
          <span matTooltip="There are {{diagnosticReportWorksheet.fieldCount}} fields with mismatching data in this worksheet">
            {{diagnosticReportWorksheet.worksheetName}} &nbsp;<span class="count"> ({{diagnosticReportWorksheet.fieldCount}})</span>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-expansion-panel  (opened)="onOpenWorksheetField(diagnosticReportWorksheet.worksheetName, mismatchField)"
                            (closed)="onCloseWorksheetField(diagnosticReportWorksheet.worksheetName, mismatchField)"
                            [expanded] = "diagnosticReportSelectedRecordInfo.fieldModelId === mismatchField.id"
                            *ngFor="let mismatchField of diagnosticReportWorksheet.diagnosticReportFieldModelsDto">
        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
          <mat-panel-title>
            <span matTooltip="There are {{mismatchField.mismatchedRecordCount}} records with mismatching data for this field">
              {{mismatchField.title}}
            </span>
            <span class="count" style="padding-left: 10px;">({{mismatchField.mismatchedRecordCount}})</span>
            <i class="fa-regular fa-arrow-up-right-from-square" matTooltip="Navigate to Field" (click)="onOpenWorkSheetCell(diagnosticReportWorksheet.worksheetName, mismatchField.rowIndex, mismatchField.columnIndex, $event)"></i>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li *ngFor="let mismatchedRecordSummary of mismatchField.mismatchedRecordSummaries" [id]="mismatchedRecordSummary.id" (click)="onAction(mismatchedRecordSummary, diagnosticReportWorksheet.worksheetName, mismatchField.title, $event)">
            <particle-dynamic-tooltip-container
              [openOption]="'hover'"
              [htmlElement]="'There are '+ mismatchedRecordSummary.counterPartsCount + ' mismatches. Click to see details.'"
              [theme]="'dark'">
              <div class="flex flex-row justify-between pointer" [ngClass]="{'selected-record': diagnosticReportSelectedRecordInfo.selectedReportId === mismatchedRecordSummary.id}">
                <span class="text"> {{mismatchedRecordSummary.displayText}}</span>
                <span class="count">({{mismatchedRecordSummary.counterPartsCount}})</span>
              </div>
            </particle-dynamic-tooltip-container>
          </li>
        </ul>
      </mat-expansion-panel>
    </mat-expansion-panel>
  </mat-accordion>
</div>
<div *ngIf="diagnosticReportWorksheetModels.length === 0" class="lable-empty-data">There are no diagnostics report available</div>
